import React from 'react';

export interface MultiFileRenderItem {
  uid: string;
  name: string;
  ext: string;
  url: string;
}

interface IProps {
  fileList: MultiFileRenderItem[];
}

export const MultiFileRender: React.FC<IProps> = ({ fileList }) => (
  <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
    {fileList.map((file) => (
      <span key={file.uid}>
        <a href={file.url} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}>
          {file.name}
        </a>
      </span>
    ))}
  </span>
);
